import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Modal } from '@pokemon/design-v2.modal'
import { useMediaQuery, useTheme } from '@mui/material'

export interface PlayExitModalProps {
  isModalOpen: boolean
  closeModal: () => void
}

export const PlayExitModal = (props: PlayExitModalProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Modal
      id="play-exit-modal"
      open={props.isModalOpen}
      onClose={props.closeModal}
      title={t('close_user_creation_modal_title', 'Back to Account Manager?')}
      primaryButtonText={t('close_user_creation_modal_cancel', 'Stay on This Page')}
      primaryOnClick={props.closeModal}
      secondaryButtonText={t('close_user_creation_modal_button', 'Go Back to Account Manager')}
      secondaryOnClick={() => navigate('/play-pokemon')}
      fullScreen={fullScreen}
    >
      {t('close_user_creation_modal_description', 'Any unsaved changes will be discarded.')}
    </Modal>
  )
}
